// enum of color codes
export enum Colors {
    // colors to be used within code from within the portal
    White = "#ffffff",
    Black = '#000000'
}